module.exports = __webpack_public_path__ + "img/aidocbg.baae9119.jpg";